import Typography from "@material-ui/core/Typography";
import React from "react";
import Box from "@material-ui/core/Box";
import {ButtonBase, IconButton} from "@material-ui/core/index";
import CloseIcon from "@material-ui/icons/Close";
import {Slide} from "@material-ui/core";

/**
 * Popover de escaneo exitoso para el ingreso de mercadería.
 * A diferencia del de validación de despacho, escanear de más no es un error,
 * por lo que no se muestra en rojo. Los artículos que no estaban en la OC se
 * indican como "Fuera de OC".
 */
export function ScanSuccessPopover(props) {
    const {open, articulo, onClick, onClose} = props;

    const enOrden = articulo.enOrden !== false;
    const cantidad = parseFloat(articulo.cantidad) || 0;
    const scanned = parseInt(articulo.scanned) || 0;

    const background = 'rgb(0, 150, 136, 1)';

    return (
        <Slide direction="up" in={open} mountOnEnter unmountOnExit>
            <Box style={{
                backgroundColor: background,
                display: 'block',
                height: '7rem',
                position: "fixed",
                bottom: '0',
                width: '100%',
                borderTop: '1px solid #BBB'
            }}>
                <ButtonBase style={{width: '100%', height: '100%', display: 'block'}} onClick={onClick}>
                    <IconButton
                        style={{position: 'absolute', right: '-5px', top: '-5px', color: 'white'}}
                        onClick={onClose}
                    >
                        <CloseIcon/>
                    </IconButton>

                    <Box style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%'}}>
                        <Typography align={"center"} variant={"body1"} style={{color: 'white'}}>
                            <b>{articulo.id || ''}</b>{!enOrden && ' (Fuera de OC)'}
                        </Typography>
                        <Typography align={"center"} variant={"body2"} style={{color: 'white'}}>
                            {articulo.detalle || 'No hay detalles del artículo escaneado'}
                        </Typography>
                        <Typography align={"center"} variant={"body1"} style={{color: 'white'}}>
                            Escaneados {scanned}{enOrden && <b> de {cantidad}</b>}
                        </Typography>
                    </Box>
                </ButtonBase>
            </Box>
        </Slide>
    );
}
